import { useEffect, useState, type ReactNode } from "react";

import { cn } from "~/lib/utils";

const AnimatedGradientText = ({ children, className }: { children: ReactNode; className?: string }) => {
  const [animate, setAnimate] = useState<boolean>(true);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setAnimate(true);
  //     setTimeout(() => {
  //       setAnimate(false);
  //     }, 10000);
  //   }, 25000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className={cn("group relative font-merriweather flex max-w-fit flex-row items-center justify-center bg-transparent pl-2 py-1.5 font-medium duration-500 ease-out [--bg-size:300%]")}>
      {/* // hover:shadow-[inset_0_-5px_10px_#8fdfff3f] */}
      <span className={cn(`py-2 text-2xl font-semibold tracking-normal font-merriweather inline ${animate ? "animate-gradient" : ""}  bg-gradient-to-r from-[#ffaa40] via-[#9c40ff] to-[#ffaa40] bg-[length:var(--bg-size)_100%] bg-clip-text text-transparent`, className)}>
        {children}
      </span>
      {/* <h3 className={cn(`font-merriweather inline ${animate ? "animate-gradient" : ""}  bg-gradient-to-r from-[#ff9f2a] via-[#800aff] to-[#ff8c00] bg-[length:var(--bg-size)_100%] bg-clip-text text-transparent`)}>{children}</h3> */}
    </div>
  );
};

export default AnimatedGradientText;

export const AnimatedGradientText2 = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div
    className={cn(
      "group relative mx-auto flex max-w-fit flex-row items-center justify-center rounded-2xl bg-transparent px-4 py-1.5 text-sm font-medium transition-shadow duration-500 ease-out [--bg-size:300%] hover:shadow-[inset_0_-5px_10px_#8fdfff3f] dark:bg-black/40",
      className,
    )}
  >
    <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:var(--bg-size)_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]" />

    {children}
  </div>
);

export const AnimatedGradientTextDemo = ({ children }: { children: ReactNode; className?: string }) => (
  <div className="z-10 flex min-h-[16rem] items-center justify-center">
    <AnimatedGradientText2>
      <h4 className={cn(`inline animate-gradient font-merriweather bg-gradient-to-r from-[#ffaa40] via-[#9c40ff] to-[#ffaa40] bg-[length:var(--bg-size)_100%] bg-clip-text text-transparent`)}>{children}</h4>
    </AnimatedGradientText2>
  </div>
);
